import { createAction, props } from '@ngrx/store';

export const SetCartPopup = createAction('[Cart popup] Set', props<{ options: OLO.State.CartPopup }>());
